import script from "./chang-factory.vue?vue&type=script&setup=true&lang=ts"
export * from "./chang-factory.vue?vue&type=script&setup=true&lang=ts"

import "./chang-factory.vue?vue&type=style&index=0&id=cedc3ea8&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cedc3ea8"]])

export default __exports__